import { createApi } from '@reduxjs/toolkit/query/react';
import { ETAResponse, JimboResponse } from '@models';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const etaApi = createApi({
  reducerPath: 'etaApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['etaApi', 'eta'],
  endpoints: (builder) => ({
    getSuburbDeliveryETA: builder.query<ETAResponse, { postcode: string }>({
      query: (query) => {
        console.log(process.env.REACT_APP_API_URL);
        return `eta/${query.postcode}`;
      },
      providesTags: ['eta'],
      transformResponse: (response: JimboResponse<ETAResponse>) => response.data!,
    }),
  }),
});

export const { useGetSuburbDeliveryETAQuery } = etaApi;
